<div class="container">
  <div class="footer-menu">
    <div *ngFor="let menu of menus" class="items {{ menu.class }}">
      <a class="title" routerLink="{{ menu.link }}">
        {{ menu.title | translate }}
      </a>
      <ul class="submenu">
        <li *ngFor="let submenu of menu.submenus">
          <a routerLink="{{ submenu.link }}">
            {{ submenu.title | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="footer-content">
    <div class="copyright">&copy; 2021 PT Integrasi Jaringan Ekosistem</div>
    <div class="contact">
      <!-- info@weave.co.id
      <br />sales@weave.co.id  -->
      corporate@weave.co.id
      <br />+62 21 765 9228
    </div>
    <div class="address">
      Fatmawati Mas, Jl. RS. Fatmawati Raya No.328-329,<br />
      Cilandak Barat, Kec. Cilandak, Kota Jakarta Selatan,<br />
      Daerah Khusus Ibukota Jakarta 12430
    </div>
    <!-- <div class="social">
      <i class="fa fa-linkedin"></i>
      <i class="fa fa-instagram"></i>
      <i class="fa fa-facebook"></i>
      <i class="fa fa-twitter"></i>
    </div> -->
  </div>
</div>
